module.exports = __webpack_public_path__ + "img/logo_phase03-300x166.c0427013.png";